@if (visible) {
    <div
        class="modal fade show"
        tabindex="-1"
        role="dialog"
        style="display: block; background: rgba(0, 0, 0, 0.5); position: fixed; inset: 0; z-index: 1050">
        <div class="modal-dialog modal-md modal-alert">
            <div
                class="modal-content"
                [ngClass]="{
                    'border-alert': alertData?.author === 'ALERT' && alertData?.isWebinar === 0,
                    'border-info': alertData?.isWebinar === 1 || alertData?.author === 'INFO',
                }">
                <div class="modal-header" style="display: flex">
                    <h4 class="modal-title pull-left" [innerHTML]="alertData?.title">
                        <i
                            class="fa"
                            [ngClass]="{
                                'fa-exclamation-triangle titleAlert':
                                    alertData?.author === 'ALERT' && alertData?.isWebinar === 0,
                                'fa-info-circle titlInfo': alertData?.isWebinar === 1 || alertData?.author === 'INFO',
                            }"></i>
                    </h4>
                    @if (!timerRunning) {
                        <button type="button" class="close btn-close text-reset" aria-label="Close" (click)="hide()">
                            <span aria-hidden="true"></span>
                        </button>
                    }
                </div>
                <div class="modal-body" style="text-align: center" [innerHTML]="alertData?.description"></div>
                <div style="border-top: 1px solid #dee2e6; text-align: center; padding: 15px">
                    @if (alertData?.isWebinar === 1) {
                        <button type="button" (click)="sendWebinarInvite('2')" class="btn btn-info text-white me-2">
                            THU 16/01/2025 10:00 - 10:30
                        </button>
                    }
                    <button
                        type="button"
                        (click)="acknowledge()"
                        class="btn text-white"
                        [disabled]="timerRunning"
                        [ngClass]="{
                            'btn-danger': alertData?.author === 'ALERT',
                            'btn-info': alertData?.author === 'INFO',
                        }">
                        Acknowledge
                        @if (timerRunning) {
                            <span>({{ acknowledgeTimer }}s)</span>
                        }
                    </button>
                </div>
            </div>
        </div>
    </div>
}
